import type { Subcategory as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * A subcategory — the leaf of the genre taxonomy — as the superadmin genre screens read and write
 * it on the internal (VP staff) schema.
 *
 * `categoryId` is selected and mapped even though the subcategory is always reached through its
 * category: the subcategory tab keys its list off the route's `categoryId`, and a saved
 * subcategory arrives on its own from the mutation payload, with no parent to infer it from.
 */

export type Subcategory = {
  id: string;
  categoryId: string;
  name: string;
};

export const fromGql = (item: GQLItem): Subcategory => take<Subcategory>(item, 'id', 'categoryId', 'name');
